import React, { useEffect } from "react";
import Quagga from "quagga";
import { handleScanCode } from "../../../../redux/features/cashierSlice";
import { useDispatch } from "react-redux";
import styles from "./ScanBarcode.module.scss";

export default function Scanner(props) {
  const dispatch = useDispatch();
  const handleScan = () => {
    Quagga.init(
      {
        inputStream: {
          type: "LiveStream",
          constraints: {
            facingMode: "environment",
          },
          area: {
            // defines rectangle of the detection/localization area
            // top: "10%", // top offset
            // right: "10%", // right offset
            // left: "10%", // left offset
            // bottom: "10%", // bottom offset
          },
        },
        locator: {
          halfSample: true,
          patchSize: "medium", // x-small, small, medium, large, x-large
          debug: {
            showCanvas: false,
            showPatches: false,
            showFoundPatches: false,
            showSkeleton: false,
            showLabels: false,
            showPatchLabels: false,
            showRemainingPatchLabels: false,
            boxFromPatches: {
              showTransformed: false,
              showTransformedBox: false,
              showBB: false,
            },
          },
        },
        numOfWorkers: 1,
        decoder: {
          readers: ["code_128_reader"],
          debug: {
            drawBoundingBox: true,
            showFrequency: true,
            drawScanline: true,
            showPattern: true,
          },
        },
        locate: true,
      },
      function (err) {
        if (err) {
          return console.log(err);
        }
        Quagga.start();
      }
    );
    Quagga.onDetected((result) => {
      if (result) {
        dispatch(
          handleScanCode({
            scannedCode: result.codeResult.code,
          })
        );
        Quagga.stop();
        window.location.reload();
      }
    });
  };

  useEffect(() => {
    handleScan();
  }, []);

  return (
    <div id="interactive" className={`${styles.scanModal} viewport`}></div>
  );
}
